import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";
import {setSortBy} from "../../../reducers/filterSlice";

/**
 * Sets filter/sortBy redux state via dispatch
 */
export function useSort() {
    const dispatch = useAppDispatch()
    return (sortingMethod) => dispatch(setSortBy(sortingMethod))
}